import { render, staticRenderFns } from "./RoomRealtimeWaitReservationPopup.vue?vue&type=template&id=0e04462c&"
import script from "./RoomRealtimeWaitReservationPopup.vue?vue&type=script&lang=js&"
export * from "./RoomRealtimeWaitReservationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports